import { render, staticRenderFns } from "./PoiDetails.vue?vue&type=template&id=378f3ead&scoped=true"
import script from "./PoiDetails.vue?vue&type=script&lang=js"
export * from "./PoiDetails.vue?vue&type=script&lang=js"
import style0 from "./PoiDetails.vue?vue&type=style&index=0&id=378f3ead&prod&scoped=true&lang=css"
import style1 from "./PoiDetails.vue?vue&type=style&index=1&id=378f3ead&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378f3ead",
  null
  
)

export default component.exports